import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";

import styles from "./Loader.scss";

export default function Loader() {
  return <CircularProgress disableShrink className={styles.loadingContainer} />;
}
